export enum ActivityType {
    Review = 0, VisitCount = 1, EventCreated
}